import { render, staticRenderFns } from "./ContractChangeSections.vue?vue&type=template&id=1763d788&scoped=true"
import script from "./ContractChangeSections.vue?vue&type=script&lang=js"
export * from "./ContractChangeSections.vue?vue&type=script&lang=js"
import style0 from "./ContractChangeSections.vue?vue&type=style&index=0&id=1763d788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1763d788",
  null
  
)

export default component.exports